import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PopupInfo from "@/components/popup/PopupInfo.vue";
import { ActionTypes, MutationTypes } from "@/store";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupInfoDeleteUserAccount',
  setup(__props) {

const { dispatch, commit } = useStore();

const clickAction = async () => {
  await dispatch(ActionTypes.DELETE_USER);
  commit(MutationTypes.HIDE_POPUP);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupInfo, {
    title: "popup.PopupInfoDeleteUserAccount.title",
    label: "popup.PopupInfoDeleteUserAccount.label",
    "btn-text": "popup.PopupInfoDeleteUserAccount.btnText",
    "cancel-btn-text": "popup.PopupInfoDeleteUserAccount.cancelBtnText",
    action: clickAction
  }))
}
}

})